<template>
  <div class="container">
    <div class="row mb-5 d-flex justify-content-center">
      <div
        class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3"
      >
        <div class="row">
          <div class="col-6">
            <h5 class="text-nowrap font-weight-bold m-0">
              Carnival Page Content
            </h5>
          </div>
          <div class="col-6 text-right">
            <b-spinner
              style="width: 17px; height: 17px"
              v-if="fetching"
              class="mr-2"
              small
            ></b-spinner>
            <icon-vue
              v-b-toggle.carnival-page-content
              :icon="['far', 'edit']"
              class="pointer"
            ></icon-vue>
          </div>
          <b-collapse
            visible
            ref="collapse"
            class="mt-3 col-12"
            id="carnival-page-content"
          >
            <hr />
            <div>
              <b-form
                @submit.prevent="
                  updateData(dbRefs.carnivalRef, carnivalContent)
                "
              >
                <b-form-group
                  id="grp-title"
                  label="Page Heading"
                  label-for="input-title"
                  description="This is text that appears atop the about page"
                >
                  <b-form-input
                    id="input-title"
                    v-model="carnivalContent.title"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="grp-subtitle"
                  label="Page Sub-Heading"
                  label-for="input-subtitle"
                  description="This is text that appears below the heading"
                >
                  <b-form-input
                    id="input-subtitle"
                    v-model="carnivalContent.subtitle"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="grp-perfAreaMainTitle"
                  label="Main Performance Areas Heading "
                  label-for="input-perfAreaMainTitle"
                  description="Text heading for main performance areas"
                >
                  <b-form-input
                    id="input-perfAreaMainTitle"
                    v-model="carnivalContent.perfAreaTitleMain"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="grp-perfAreaTitleExtra"
                  label="Extra Performance Areas Heading "
                  label-for="input-perfAreaTitleExtra"
                  description="Text heading for extra performance areas"
                >
                  <b-form-input
                    id="input-perfAreaTitleExtra"
                    v-model="carnivalContent.perfAreaTitleExtra"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="grp-closing"
                  label="Closing Text"
                  label-for="input-closing"
                  description="Text below performance areas, actions heading"
                >
                  <b-form-input
                    id="input-closing"
                    v-model="carnivalContent.closing"
                  ></b-form-input>
                </b-form-group>
                <b-button
                  class="btn-carnival px-5 py-1"
                  type="submit"
                  variant="outline-success"
                  :disabled="saving"
                >
                  Save
                </b-button>
              </b-form>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../eventBus';
import { defaultCarnivalContent } from '../../utils/content';
import DataStreamListener from '../../mixins/dataListener';
import AddDataHandler from '../../mixins/genericAddDataHandler';

export default {
  data() {
    return {
      carnivalContent: { ...defaultCarnivalContent },
    };
  },
  mixins: [DataStreamListener, AddDataHandler],
  async mounted() {
    this.fetchSingleData(this.dbRefs.carnivalRef, defaultCarnivalContent);
    EventBus.$on('dataFetched', (carnivalContent) => {
      this.carnivalContent = carnivalContent;
      setTimeout(() => {
        this.fetching = false;
      }, 1000);
    });
  },
};
</script>
